<mat-dialog-content class="mat-typography">
    <h2>Fiche de travaux</h2>
    <form class="grid grid-cols-2 gap-4 w-full px-8" [formGroup]="selectTypeForm" (ngSubmit)="onFormSubmit()">
        <mat-form-field>
            <mat-label>Type</mat-label>
            <mat-select matSelect formControlName="types" multiple>
                <input type="text" formControlName="searchText" placeholder="Rechercher" class="pt-2 pb-2 ps-3">
                <mat-option *ngFor="let workOrderType of filterWorkOrderTypes" [value]="workOrderType.name">
                    {{workOrderType.name}}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field>
                <mat-label>Pièce</mat-label>
            <mat-select matSelect formControlName="piece_id">
                <mat-option *ngFor="let piece of pieces" [value]="piece.id">
                    {{piece.nom_piece}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </form>
</mat-dialog-content>


<mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="undefined">Annuler</button>
    <button type="submit" mat-flat-button (click)="onFormSubmit()" [color]="'primary'">Enregistrer</button>
</mat-dialog-actions>
